import { useState, useEffect } from 'react';

export const useImagePreview = () => {
  const [imagePreviewUrls, setImagePreviewUrls] = useState<Map<string, string>>(new Map());

  // Create preview URL for a file
  const createPreview = (key: string, file: File | null) => {
    // Clean up previous URL for this key if it exists
    const oldUrl = imagePreviewUrls.get(key);
    if (oldUrl) {
      URL.revokeObjectURL(oldUrl);
    }

    if (file) {
      // Create new preview URL
      const newUrl = URL.createObjectURL(file);
      setImagePreviewUrls((prev) => new Map(prev).set(key, newUrl));
      return newUrl;
    } else {
      // Remove preview URL if no file
      setImagePreviewUrls((prev) => {
        const newMap = new Map(prev);
        newMap.delete(key);
        return newMap;
      });
      return null;
    }
  };

  // Remove preview for a specific key
  const removePreview = (key: string) => {
    const url = imagePreviewUrls.get(key);
    if (url) {
      URL.revokeObjectURL(url);
      setImagePreviewUrls((prev) => {
        const newMap = new Map(prev);
        newMap.delete(key);
        return newMap;
      });
    }
  };

  // Get preview URL for a key
  const getPreview = (key: string) => imagePreviewUrls.get(key);

  // Cleanup all object URLs on unmount
  useEffect(() => {
    return () => {
      imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [imagePreviewUrls]);

  return {
    createPreview,
    removePreview,
    getPreview,
    imagePreviewUrls,
  };
};
